import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Компонент для скролла наверх при навигации.
 * Используется в App.jsx для автоматического скролла при переходе между страницами.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
